import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M6.6 4.2H5.4V3h1.2zm0 4.8H5.4V5.4h1.2zm-.594 3A5.997 5.997 0 0 0 12 6c0-3.312-2.682-6-5.994-6A6.003 6.003 0 0 0 0 6c0 3.312 2.688 6 6.006 6M6 1.2c2.652 0 4.8 2.148 4.8 4.8S8.652 10.8 6 10.8A4.8 4.8 0 0 1 1.2 6c0-2.652 2.148-4.8 4.8-4.8"
    }, null, -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "info_black"}) } }